import React from 'react';
import { formatSignedUsd, formatUsd } from '../../utils/format';
interface MoneyProps {
  value: number;
  signed?: boolean;
  className?: string;
}
export function Money({
  value,
  signed = false,
  className = ''
}: MoneyProps) {
  return <span className={`tabular-nums ${value < 0 ? 'text-sf-red' : ''} ${className}`} data-id="element-834" data-mp="25cx8v52c8858">
      {signed ? formatSignedUsd(value) : formatUsd(value)}
    </span>;
}